/**
 * Normalises the raw editing rows of a string-list editor into the clean array
 * to persist: trims each row (internal spaces preserved), drops empty rows, and
 * removes exact, case-sensitive duplicates while keeping the first occurrence
 * and original order.
 */
export function normalizeStringList(rows: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const row of rows) {
    const trimmed = row.trim();
    if (trimmed.length === 0) continue;
    if (seen.has(trimmed)) continue;
    seen.add(trimmed);
    result.push(trimmed);
  }
  return result;
}
